import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import TextField from "@mui/material/TextField";
import { getCurrentMonth,CurrentMonthInput ,CreateCurrentMonth} from './../../../services/global_redux/globale_actions/Currentmonth.action';
import { getClients} from './../../../services/global_redux/globale_actions/Client.action';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import "./UploadForm.css";
import { getUserRole} from "./../../../services/global_redux/globale_actions/Role.action"
import { fetchgenerateAttendanceRegister } from './../../../services/register_redux/register_actions/AttendanceRegister.action';
import branch_icon from "../../../assets/register_assets/inputMatix/branch_icon.png"
import current_month_icon from "../../../assets/register_assets/inputMatix/current_month_icon.png"
import financial_year from "../../../assets/register_assets/inputMatix/financial_year.png"
import { IoIosArrowForward } from "react-icons/io";
import * as XLSX from "xlsx";
import input_matrix_icon from "../../../assets/register_assets/inputMatix/input_matrix.png"
import emp_master_icon from "../../../assets/register_assets/inputMatix/emp_master_icon.png"
import attendance_overide_icon from "../../../assets/register_assets/inputMatix/attendance_overide_icon.png"
import ctc_master_icon from "../../../assets/register_assets/inputMatix/ctc_master_icon.png"
import leave_register_icon from "../../../assets/register_assets/inputMatix/leave_register_icon.png"
import maternity_benefits_icon from "../../../assets/register_assets/inputMatix/maternity_benefits_icon.png"
import other_inputs_icon from "../../../assets/register_assets/inputMatix/other_inputs_icon.png"
import salary_advance_icon from "../../../assets/register_assets/inputMatix/salary_advance_icon.png"
import salary_register_icon from "../../../assets/register_assets/inputMatix/salary_register_icon.png"
import tn_forms_icon from "../../../assets/register_assets/inputMatix/tn_forms_icon.png"
import emp_separation_icon from "../../../assets/register_assets/inputMatix/emp_separation_icon.png"
import intomarkIcon from "../../../assets/register_assets/inputMatix/intomarkIcon.png"
import Select from 'react-select';
import { CreateGenerateFormInput ,getClientBaseUnitsForm } from './../../../services/register_redux/register_actions/generateForm.action';
import { getUnits } from './../../../services/global_redux/globale_actions/Unit.action';
import { getForm ,getInputMatrixActivities } from './../../../services/register_redux/register_actions/Form.action';
import file_upload_icon from '../../../assets/reUsableTemplates_assets/file_upload_icon.png';
import file_uploaded_icon from '../../../assets/reUsableTemplates_assets/file_uploaded_icon.png';
import into from '../../../assets/reUsableTemplates_assets/into.png';
import { login } from '../../../services/global_redux/globale_actions/Login.action';

function UploadForm({ showSnackbar, setLoading }) {
  const [useMonths, setUseMonth] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(null);
    const [permissionsSubmodules, setPermissionsSubmodules] = useState(null);
    const dispatch = useDispatch();
    const { date } = useParams();
    const [selectedClientId, setSelectedClientId] = useState();
    const [clientIDs, setClientIDs] = useState(null);
    const [open, setOpen] = useState(false);
    const [currentOpen, setCurrentOpen] = useState(false);
    const [monthFilterList,setMonthFilterList] = useState([]);
    const [yearFilterList,setYearFilterList] = useState([]);
    const [totalBranchCount,setTotalBranchCount] = useState(0);
    const [isAttendance,setIsAttendance] = useState(false);
    const [isDataExists, setIsDataExists] = useState(false);
    const [isAttendanceExistPrevious, setIsAttendanceExitPrevious] = useState(false)
    const [isAttendanceExist,setIsAttendanceExist] = useState(false);
    const [totalBranchAccessCount,setTotalBranchAccessCount] = useState(0);
    const [selectedYear, setSelectedYear] = useState('');
    const [selectedMonth, setSelectedMonth] = useState('');
    const [allMonthsData, setAllMonthsData] = useState([]);
    const [dater ,setDater] = useState('')
    const [step, setStep] = useState(1);
    const [currentSetp, setCurrentStep] = useState(1);
    const [monthError, setMonthError] = useState(false);
    const [load, setLoad] = useState(false);
    const [selectedCurrentMonth, setSelectedCurrentMonth] = useState("");
    const [selectedFormCategory, setSelectedFormCategory] = useState('1'); // '1' = S&E, '2' = CLRA
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];


    const handleClickOpen = () => {
      if(load == true){
       
        if(!isDataExists[0]){
          setCurrentOpen(true);
        }
        // else if (!isAttendanceExistPrevious && !isAttendance) {
        //   setCurrentOpen(true); // Open Current Month dialog
        // } 
        else {
          setOpen(true); // Open Previous/Next Month dialog
        }
      }};
      // else{
      //   showSnackbar("No branches are available. Please add a branch before proceeding with the current month setup.", "error");  
      // }
    
    const handleClose = () => {
        setOpen(false);
    };

    const handleCurrentMonthSelection = () => {
        setCurrentOpen(true);
            };
    const handleCurrentMonthClose = () => {
        setCurrentOpen(false);
        setSelectedCurrentMonth(""); 
        setMonthError(false);
    };
    

    const nextMonth = async () => {
      if (!isAttendanceExist || !isAttendance) {
        showSnackbar("Please generate attendance before moving the month", "error");
        return;
      }
      setOpen(false);
      const client_id = sessionStorage.getItem('selectedClient');
      const current_month = getNextMonth(useMonths);
      const nextDateJson = JSON.stringify({ current_month, client_id });
      const currentSelectedMonth = `${selectedCurrentMonth}-01`;


      try {
        setLoading(true);
        const response = await dispatch(CurrentMonthInput(nextDateJson));

        if (response?.success) {
          window.location.replace(`/input-matrix/${current_month}`);
          return;
        }

        showSnackbar(response?.message || "Failed to update current month", "error");
      } catch (err) {
        console.error("Failed to update current month:", err);
        showSnackbar(
          typeof err === 'string' ? err : (err?.message || "Failed to update current month"),
          "error"
        );
      } finally {
        setLoading(false);
      }
    };


    const CreateMonth = async () => {
      setCurrentOpen(false);

      const client_id = sessionStorage.getItem("selectedClient");
      const current_month = `${selectedCurrentMonth}-01`;

      const nextDateJson = JSON.stringify({
        current_month,
        client_id,
      });

      try {
        setLoading(true);

        const response = await dispatch(CreateCurrentMonth(nextDateJson));

        if (response?.success) {
          window.location.replace(`/input-matrix/${current_month}`);
          return;
        }

        showSnackbar(response?.message || "Failed to update current month", "error");
      } catch (err) {
        console.error(err);
        showSnackbar(
          typeof err === "string" ? err : err?.message || "Failed to update current month",
          "error"
        );
      } finally {
        setLoading(false);
      }
    };


     const previousMonth = async () => {
      setOpen(false);
      const client_id = sessionStorage.getItem('selectedClient');
      const current_month = getPreviousMonth(useMonths);
      const nextDateJson = JSON.stringify({ current_month, client_id });

      try {
        setLoading(true);
        const response = await dispatch(CurrentMonthInput(nextDateJson));

        if (response?.success) {
          window.location.replace(`/input-matrix/${current_month}`);
          return;
        }

        showSnackbar(response?.message || "Failed to update current month", "error");
      } catch (err) {
        console.error("Failed to update current month:", err);
        showSnackbar(
          typeof err === 'string' ? err : (err?.message || "Failed to update current month"),
          "error"
        );
      } finally {
        setLoading(false);
      }
    };

    
    const fetchAllClient = async () => {
      try {
          const response = await dispatch(getClients());
          if (response.data) {
                setClientIDs(response.data);
          }
      } catch (err) {
          console.error("Failed to fetch clients:", err);
      }
  }
  useEffect(() => {
          fetchAllClient();
    }, [dispatch]);
    
    function getNextMonth(dateString) {
        const date = new Date(dateString);

        let nextMonth = date.getMonth() + 1;
        let year = date.getFullYear();
        if (nextMonth > 11) {
            nextMonth = 0;
            year++;
        }
        date.setMonth(nextMonth);
        date.setFullYear(year);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    function getAllMonth(dateString) {
        const date = new Date(dateString);


        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    function getPreviousMonth(dateString) {
        const date = new Date(dateString);

        let previousMonth = date.getMonth() - 1;
        let year = date.getFullYear();
        if (previousMonth < 0) {
            previousMonth = 11;
            year--;
        }
        date.setMonth(previousMonth);
        date.setFullYear(year);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }
    const usecurrdate = date;

    const fetchcurrmonth = async () => {
        try {
            const response = await dispatch(getCurrentMonth());
            setUseMonth(new Date(response.data[0].current_month));
            setCurrentMonth(response.data[0].current_month);

            if(response.data[0].current_month === null){
              setCurrentOpen(true);
            }

        } catch (err) {
            console.error("Failed to fetch clients:", err);
        }
    };

    useEffect(() => {
        fetchcurrmonth();
    }, [dispatch, date]);

    const isValidDate = (d) => !isNaN(new Date(d).getTime());

    const getUserPermission = async () => {
        try {
            const response = await dispatch(getUserRole());
            const rawPermissions = response?.data?.permissions;
            const parsedPermissions = typeof rawPermissions === "string"
                ? JSON.parse(rawPermissions)
                : Array.isArray(rawPermissions) && typeof rawPermissions[0] === "string"
                ? JSON.parse(rawPermissions[0])
                : rawPermissions;
   
            parsedPermissions.forEach((item) => {
                const { section, module, sub_module } = item;
   
                if (section === "InputMatrix" && module === "InputMatrix") {
                    setPermissionsSubmodules(sub_module);
                }
            });
            // setPermissionsSubmodules(response.data);

        } catch (err) {
          console.error("Failed to fetch states:", err);
        }
    };
      useEffect(() => {
        getUserPermission();
      }, [dispatch]);
      const checkSubModules = ()=>{
        const modules = []
        if (permissionsSubmodules != null) {
            permissionsSubmodules.forEach(({action ,name})=>{
                modules.push(name);
            })
        }
        return modules;
      }
      const checkSubModulesget = checkSubModules();
      const handleClientChange = (id)=>{
        sessionStorage.setItem('selectedClient', id);
        window.location.reload();
      }
      useEffect(() => {
        const storedClientID = sessionStorage.getItem('selectedClient');
        if (storedClientID && storedClientID != null) {
          if(storedClientID !== "null"){
            setSelectedClientId(storedClientID);
          }
        }
      }, []);
      
      // useEffect(() => {
      //     if (selectedClientId && currentMonth == null) {
      //         setCurrentOpen(true);
      //     } else {
      //         setCurrentOpen(false);
      //     }
      // }, [selectedClientId,currentMonth]);

    //   Generate forms
      const [isVisible, setIsVisible] = useState(false);
      const [isVisibleCompleteError, setIsVisibleCompleteError] = useState(false);
      const [selectedFormtable, setSelectedFormtable] = useState('Generate Form');
      const [selectedForm, setSelectedForm] = useState("");
      const [selectedForms, setSelectedForms] = useState([]);
      const [successMessage, setSuccessMessage] = useState("");
      const [failMessage, setFailMessage] = useState("");
      const [selectedDate, setSelectedDate] = useState(null);
      const defaultClientID = sessionStorage.getItem("selectedClient");
      const [clientID, setClientID] = useState(defaultClientID);
      const [selectedUnit, setSelectedUnit] = useState("");
      const [clientName, setClientName] = useState("");
      const [formName, setFormName] = useState("");
      const [unitOptions, setUnitOptions] = useState([]);
      const [file, setFile] = useState(null);
        const [dragActive, setDragActive] = useState(false);
      const [selectedFormat, setSelectedFormat] = useState('excel');


   
        const handleToggleNonGenerateForm = () => {
          showSnackbar("Cannot Generate form for for the historical month", "error");
        };
        const showFormRelatedErrorIndepth = () =>{
          if(totalBranchAccessCount.length > 0){
            setIsVisibleCompleteError(!isVisibleCompleteError);
          }else{
            showSnackbar("Something Went wrong .Please Try again after sometimes", "error");
          }

        }
        const handleToggleGenerateForm = () => {
          if(totalBranchAccessCount.length > 0){
            showSnackbar("Please Generate Attendance Before Generating Forms", "error");
          }else if(!isAttendanceExist){
            showSnackbar("Please Generate Attendance Before Generating Forms", "error");
          }else{
            setIsVisible(!isVisible);
          }
      };




    const handleChangeforms = (e) => {
        setSelectedFormtable(e.target.value);
    };
    const handleFormSubmit = async (e) => {
      e.preventDefault();
      setSuccessMessage("");
      setFailMessage("");
      setLoading(true);
  
      try {
        const user = JSON.parse(sessionStorage.getItem('user'));
        const company_code = user?.company_code;

        if (selectedFormtable === 'Generate Form') {
          if (!selectedUnit) {
            showSnackbar("Please select branch", "error");
            setFailMessage("Please select branch");
            return;
          }
          if (selectedForms.length === 0) {
            showSnackbar("Please select at least one form", "error");
            setFailMessage("Please select at least one form");
            return;
          }

          const formDataInput = {
            client_id: clientID,
            unit_id: selectedUnit,
            date: dater,
            form_type: selectedForms[0], // backward compatibility for backend internals
            form_types: selectedForms,
            client_name: clientName,
            company_code: company_code,
            format: selectedFormat,
          };
          const result = await dispatch(CreateGenerateFormInput(formDataInput));
          if (result.success) {
            const failuresSummary = result?.data?.failuresSummary;
            if (failuresSummary) {
              const msg = `${selectedForms.length} form(s) processed with some failures`;
              setSuccessMessage(msg);
              setFailMessage(failuresSummary);
              showSnackbar(msg, "error");
            } else {
              const msg = `${selectedForms.length} form(s) generated`;
              setSuccessMessage(msg);
              showSnackbar(msg, "success");
            }
          } else {
            const failureList = Array.isArray(result?.payload?.failures) ? result.payload.failures : [];
            const failureDetails = failureList.length
              ? failureList.map((item) => `${item.form_name}: ${item.error}`).join(" | ")
              : null;
            const reasonRaw =
              result?.message?.error ||
              result?.message?.message ||
              (typeof result?.message === "string" ? result.message : "Generation failed");
            setFailMessage(`Failed to generate selected forms. ${reasonRaw}${failureDetails ? ` | ${failureDetails}` : ""}`);
            showSnackbar("Failed to generate selected forms", "error");
          }
        } else {
          const formDataInput = {
            client_id: clientID,
            unit_id: selectedUnit,
            date: dater,
            form_type: selectedForm,
            client_name: clientName,
            company_code: company_code,
            format: selectedFormat,
          };
          const result = await dispatch(CreateGenerateFormInput(formDataInput));

          if (result.success) {
            setSuccessMessage("Form Generated Successfully");
            showSnackbar("Form Generated Successfully", "success");
          } else {
            setFailMessage(result.message);
            showSnackbar(result.message, "error");
          }
        }
      } catch (error) {
        console.error("Error generating form:", error);
        setFailMessage("No record found for given input. Please try again.");
        showSnackbar("No record found. Please try again.", "error");
      } finally {
        setLoading(false);
      }
    };
    
    const handleUnitChange = (event) => {
        const unitID = event.target.value;
        setSelectedUnit(unitID);
        setSelectedForm("");
        setSelectedForms([]);
        if (!unitID) {
          setSelectedFormCategory('1');
          return;
        }
        const unit = unitOptions.find((u) => u.unit_id === unitID);
        const branchType = String(unit?.branch_type || '1').trim();
        const defaultCategory = branchType === '2' ? '2' : branchType === '3' ? '3': '1';
        setSelectedFormCategory(defaultCategory);
        fetchForm(unitID);
    };
    const fetchForm = async (unit_id) => {
      setLoading(false);
      try {
        const response = await dispatch(getForm(unit_id));
        if (response.success === true) {
          setFailMessage("");
          setFormName(response.data);
        } else {
          setFailMessage(response.message);
          showSnackbar(response.message, "error");
        }
      } catch (error) {
        console.error("Error:", error);
        setFailMessage("Failed to fetch form details.");
        showSnackbar("Failed to fetch form details.", "error");
      } finally {
        setLoading(false);
      }
    };
    const getInputMatrixActivitiesFetch = async () => {
      try {
        const response = await dispatch(getInputMatrixActivities());
        if (response.success === true) {
          setTotalBranchCount(response.data.total_unit_count);
          setIsAttendance(response.data.attendance);
          setIsAttendanceExist(response.data.attendance_exists);
          setTotalBranchAccessCount(response.data.missing_employees || []);
          setIsAttendanceExitPrevious(response.data.attendance_exists_previous);
          setIsDataExists(response.data.data_exists);
          const data = response.data.months;
          const years = [...new Set(data.map(item => item.split('-')[0]))];
    
          setAllMonthsData(data);
    
          setYearFilterList(years);
          setLoad(true);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    
    useEffect(() => {
      getInputMatrixActivitiesFetch();
    }, [dispatch, date]);

    useEffect(() => {
        const refreshMonthData = () => {
            fetchcurrmonth();
            getInputMatrixActivitiesFetch();
        };
        const onPageShow = (event) => {
            if (event.persisted) refreshMonthData();
        };
        window.addEventListener('pageshow', onPageShow);
        return () => window.removeEventListener('pageshow', onPageShow);
    }, [dispatch]);
    useEffect(() => {
      if (selectedYear) {
        const monthsForSelectedYear = [...new Set(
          allMonthsData
            .filter(item => item.split('-')[0] === String(selectedYear))
            .map(item => {
              const monthNum = parseInt(item.split('-')[1], 10);
              return monthNames[monthNum - 1];
            })
        )].sort((a, b) => monthNames.indexOf(a) - monthNames.indexOf(b));
        setMonthFilterList(monthsForSelectedYear);
      } else {
        setMonthFilterList([]);
      }
      }, [selectedYear,setYearFilterList,allMonthsData]);
    const handleYearChange = (year) => {
      setSelectedYear(year);

      const monthsForSelectedYear = year
        ? [...new Set(
            allMonthsData
              .filter(item => item.split('-')[0] === year)
              .map(item => {
                const monthNum = parseInt(item.split('-')[1], 10);
                return monthNames[monthNum - 1];
              })
          )].sort((a, b) => monthNames.indexOf(a) - monthNames.indexOf(b))
        : [];
      setMonthFilterList(monthsForSelectedYear);
      if (!year) setSelectedMonth('');
    };    
    const handleMonthChange = (month) => {
      if (!selectedYear || !month) return;
      const monthIdx = monthNames.indexOf(month);
      if (monthIdx < 0) return;
      setSelectedMonth(month);
      const monthNum = String(monthIdx + 1).padStart(2, '0');
      window.location.replace(`/input-matrix/${selectedYear}-${monthNum}-01`);

    }
    
    useEffect(()=>{
      if (usecurrdate) {
          const dateObject = new Date(usecurrdate);
          const year = String(dateObject.getFullYear());
          const month = String(dateObject.getMonth() + 1).padStart(2, '0');
          const day = String(dateObject.getDate()).padStart(2, '0');
          setDater (`${year}-${month}-${day}`);
          setSelectedYear(year);
          setSelectedMonth(monthNames[parseInt(month, 10) - 1]);
      } else if (isValidDate(useMonths)) {
          const dateObject = new Date(useMonths);
          const year = String(dateObject.getFullYear());
          const month = String(dateObject.getMonth() + 1).padStart(2, '0');
          const day = String(dateObject.getDate()).padStart(2, '0');
          setDater (`${year}-${month}-${day}`);
          setSelectedYear(year);
          setSelectedMonth(monthNames[parseInt(month, 10) - 1]);
      }

    },[usecurrdate,useMonths]) 
    
  const parsedDate = new Date(useMonths);
  const formattedDate = parsedDate?.toLocaleDateString('en-US', { year: 'numeric', month: 'short' });
  const formOptions = Array.isArray(formName)
  ? formName.map((form) => ({
      value: form.form_name,
      label: form.form_name,
    }))
  : [];

  const selectedUnitData = unitOptions.find((u) => u.unit_id === selectedUnit);
  const branchType = String(selectedUnitData?.branch_type || '').trim();
  const isOnRoll = Boolean(selectedUnit && branchType.includes('1'));
  const isContractor = Boolean(selectedUnit && branchType.includes('2'));
  const isBoth = Boolean(selectedUnit && branchType.includes('3'))

  const handleFormCategoryChange = (category) => {
    if (!selectedUnit) return;
    if (category === '1' && !isOnRoll) return;
    if (category === '2' && !isContractor) return;
    if (category == '3' && !isBoth) return;
    setSelectedFormCategory(category);
  };

  const handleFormTypeChange = (event) => {
    setSelectedForm(event.target.value);
  };
  const toggleFormSelection = (formValue) => {
    setSelectedForms((prev) =>
      prev.includes(formValue)
        ? prev.filter((value) => value !== formValue)
        : [...prev, formValue]
    );
  };
  const toggleSelectAllForms = () => {
    const allValues = formOptions.map((option) => option.value);
    if (selectedForms.length === allValues.length) {
      setSelectedForms([]);
    } else {
      setSelectedForms(allValues);
    }
  };
  useEffect(() => {
    const validFormValues = new Set(formOptions.map((option) => option.value));
    setSelectedForms((prev) => prev.filter((value) => validFormValues.has(value)));
  }, [formName]);
  const fetchUnitIDs = async (clientID) => {
    setLoading(true);
    try {
      const response = await dispatch(getClientBaseUnitsForm(clientID));
      const filteredUnits = response.data.filter(
        (unit) => unit.client_id === clientID
      );
      if (filteredUnits.length > 0) {
        setClientName(filteredUnits[0].client_name);
      } else {
        setClientName("");
      }
      setUnitOptions(filteredUnits);
    } catch (error) {
      setFailMessage("Error fetching Branch IDs. Please try again.");
      console.error("Error fetching Branch IDs:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (defaultClientID) {
      fetchUnitIDs(defaultClientID);
    }
  }, [defaultClientID]);
  const customStyles = {
    menuList: (provided) => ({
        ...provided,
        maxHeight: '100px',
        overflowY: 'auto',
        fontSize:"12px"
    }),
    control: (provided) => ({
        ...provided,
        fontSize: '12px',
        fontWeight: 500,
        minHeight: '30px',    // Ensure control is exactly 30px tall
        height: '50px',       // Force height
        padding: '0 10px',    // Adjust horizontal padding
        backgroundColor: 'rgb(249,250,251)',
        border: '1px solid white',
        boxShadow: 'none',
      }),
      valueContainer: (provided) => ({
        ...provided,
        height: '30px',
        padding: '0 6px',
      }),
      input: (provided) => ({
        ...provided,
        margin: '0',
        padding: '0',
      }),
      singleValue: (provided) => ({
        ...provided,
        fontSize: '12px',
        fontWeight: 500,
      }),
      menu: (provided) => ({
        ...provided,
        fontSize: '12px',
      }),
      option: (provided, state) => ({
        ...provided,
        fontSize: '12px',
        backgroundColor: state.isFocused ? '#eee' : 'white',
        color: 'black',
      }),
};

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile.name.match(/\.(xls|xlsx)$/i)) {
      alert("Only Excel files are allowed");
      return;
    }
    if (selectedFile) {
      setFile(selectedFile);
      setFile({
        name: selectedFile.name,
        size: (selectedFile.size / (1024 * 1024)).toFixed(2) + " MB",
      });
    }
  };
  const removeFile = () => {
    setFile(null);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const droppedFile = e.dataTransfer.files[0];
      if (!droppedFile.name.match(/\.(xls|xlsx)$/i)) {
        alert("Only Excel files are allowed");
        return;
      }else{
        setFile(droppedFile);
        setFile({
          name: droppedFile.name,
          size: (droppedFile.size / (1024 * 1024)).toFixed(2) + " MB",
        });
      }
    }
  };

  // useEffect(() => {
  //   if(date){
  //     alert(date);
  //   }
  // }, [date]);
  
    return (
        <div className="container-fluid inputmatrixMaincontainer ">

            {/* Header Section */}
            <div className={`inputmatrixHeaderCard ${
                    selectedClientId ? '' : 'disabled-overlay1'
                }`}>
                <div className="d-flex justify-content-between div1">
                    <div className={` ${
                        selectedClientId ? '' : 'disabled-overlay'
                    }`}> 
                        <h5>
                            {clientIDs?.find(client => client.client_id === selectedClientId)?.client_name || 'Organization not found'}
                        </h5>

                        <p>Org. ID : {selectedClientId || 'Not Selected'}</p>
                    </div>
                    <div className="custom-select-wrapper">
                        <select
                            id="clientSelect"
                            className="custom-client-select"
                            value={selectedClientId}
                            onChange={(e) => handleClientChange(e.target.value)}
                        >
                            <option value="">Organization Name</option>
                            {clientIDs?.map((client) => (
                                <option key={client.client_id} value={client.client_id}>
                                    {client.client_name}
                                </option>
                            ))}
                        </select>
                        {!selectedClientId &&
                            <div className="tooltip1">
                                Select Organization name to proceed forward
                            </div>
                        }
                    </div>

                </div>

                <div className={`branchMainCard d-flex gap-3 ${
                    selectedClientId ? '' : 'disabled-overlay'
                }`}>
                    <div className="d-flex align-items-center gap-2">
                        
                        <div>
                            <h6><img src={branch_icon} alt="Branch Icon" className="info-icon" />Branch</h6>
                            <p className='branch_data dataBorderDesign'>{totalBranchCount}</p>
                        </div>
                    </div>
                    <div className="vertical_line"></div>
                    <div className="d-flex align-items-center gap-2">
                        
                        <div>
                            <h6><img src={current_month_icon} alt="Calendar Icon" className="info-icon" />Current Month</h6>
                            {/* {useMonths ?? <p className='current_month_data dataBorderDesign'>{new Date(useMonths)}</p>} */}
                            {dater === currentMonth ? (
                              <button className='current_month_data dataBorderDesign' style={{ cursor:"pointer" }} onClick={handleClickOpen} disabled={!selectedClientId}>
                                {currentMonth ? new Date(currentMonth).toLocaleString('default', { month: 'long', year: 'numeric' }) : 'No Data Available'}
                              </button>
                            ) : (
                              <a className='current_month_data dataBorderDesign btn' href={currentMonth ? `/input-matrix/${currentMonth}` : '/input-matrix'}>
                                {currentMonth ? new Date(currentMonth).toLocaleString('default', { month: 'long', year: 'numeric' }) : 'No Data Available'}
                              </a>
                            )}
                            
                        </div>
                    </div>
                </div>
            </div>

            <div className={`inputmatrixBodyCard ${
                selectedClientId ? '' : 'disabled-overlay'
            }`}>
                <div className="d-flex justify-content-between align-items-center bg-white">
                    <div className='mainHeader d-flex'><div className="mainHeaderIcon"><img src={input_matrix_icon} alt="" /></div><h5>Input Matrix</h5></div>
                    <div className='d-flex '>
                        <div className=''>
                        <div className="select-Financial-year position-relative me-2">
                            <img src={financial_year} className="select-icon" alt="Calendar Icon"/>
                            <select className="custom-select"
                              value={selectedYear}
                              onChange={(e) => handleYearChange(e.target.value)}
                            >
                              <option value="">Year</option>
                              {yearFilterList.map((year, idx) => (
                                <option key={idx} value={year}>
                                  {year}
                                </option>
                              ))}
                            </select>
                        </div>
                        </div>
                          <select className='selectMonth'
                            value={selectedMonth}
                            onChange={(e) => handleMonthChange(e.target.value)}
                            disabled={!selectedYear}
                          >
                            <option value="">Month</option>
                            {monthFilterList.map((month, idx) => (
                            <option key={idx} value={month}>
                              {month}
                            </option>
                            ))}
                          </select>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="row inputMatrixGrid mt-1">
                                                {(checkSubModulesget)?.includes('Employee Master')&&(
                            <CardItem label="Employee Master" image={emp_master_icon} link={`/input-matrix/employee-master/${dater}`} iconBackground="#0057ff"  hoverBackground="#e5eeff" dataContent="Add or update employee records in bulk."/>
                                                )}
                                                  {(checkSubModulesget)?.includes('CTC Master')&&(
                              <CardItem label="CTC Master" image={ctc_master_icon}link={`/input-matrix/ctc-master/${dater}`} iconBackground="#4ad991"  hoverBackground="#e9faf2"  dataContent="Add or update employee salary details in bulk." />
                                                  )}
                                                {(checkSubModulesget)?.includes('Salary Register')&&(
                            <CardItem label="Salary Register" image={salary_register_icon} link={`/input-matrix/salary-register/${dater}`} iconBackground="#fec53d"  hoverBackground="#fff8e8" dataContent="Add monthly employee Salary records in bulk." />
                                                )}
                                                {(checkSubModulesget)?.includes('Leave Register')&&(
                            <CardItem label="Leave Register" image={leave_register_icon} link={`/input-matrix/leave-register/${dater}`} iconBackground="#8280ff"  hoverBackground="#f0f0ff"  dataContent="Add employee leave records in bulk." />
                                                )}
                                                {(checkSubModulesget)?.includes('Attendance Register Override')&&(
                            <CardItem label="Attendance Override" image={attendance_overide_icon} link={`/input-matrix/attendance-override/${dater}`} iconBackground="#ff9066"  hoverBackground="#fff2ed"  dataContent="Add manual corrections to attendance records." />
                                                )}
                                                {(checkSubModulesget)?.includes('Maternity Benefits')&&(
                            <CardItem label="Maternity Benefits" image={maternity_benefits_icon} link={`/input-matrix/maternity-benefits/${dater}`} iconBackground="#bd0084"  hoverBackground="#f7e0f0"  dataContent="Add employee maternity benefit details." />
                                                )}
                                                {(checkSubModulesget)?.includes('Salary Advance')&&(
                            <CardItem label="Salary Advance" image={salary_advance_icon} link={`/input-matrix/salary-advances/${dater}`} iconBackground="#7800c3"  hoverBackground="#efe0f8"  dataContent="Add employee salary advance records." />
                                                )}
                                                {(checkSubModulesget)?.includes('Other Inputs')&&(
                            <CardItem label="Other Inputs" image={other_inputs_icon} link={`/input-matrix/other-inputs/${dater}`} iconBackground="#16b9f9"  hoverBackground="#e3f7fe"  dataContent="Add additional payroll-related inputs." />
                                                )}
                                                {(checkSubModulesget)?.includes('Tamil Nadu Form VI')&&(
                            <CardItem label="TN Form VI" image={tn_forms_icon} link={`/input-matrix/tamil-nadu-form-vi/${dater}`} iconBackground="#d80000"  hoverBackground="#fae0e0"  dataContent="Add employee details for TN compliance." />
                                                )}
                                                {(checkSubModulesget)?.includes('Employee Separation')&&(
                            <CardItem label="Employee Separation" image={emp_separation_icon} link={`/input-matrix/get-emp-separation/${dater}`} iconBackground="#81cb00"  hoverBackground="#f0f9e0"  dataContent="Add employee exit details in bulk." />
                                                )}
                                                {(checkSubModulesget)?.includes('Staffing Agencies')&&(
                            <CardItem label="Staffing Agencies" image={salary_register_icon} link={`/input-matrix/staffing-agencies/${dater}`} iconBackground="#81cb00"  hoverBackground="#f0f9e0"  dataContent="Add staffing agency details." />
                                                )}
                                                {(checkSubModulesget)?.includes('Leave Opening Balance')&&(
                            <CardItem label="Leave Opening Balance" image={leave_register_icon} link={`/input-matrix/leave-opening-balance/${dater}`} iconBackground="#81cb00"  hoverBackground="#f0f9e0"  dataContent="Add employee opening leave balances." />
                                                )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Action Buttons */}
            <div className={`mt-4 mb-4 d-flex gap-3 inpumatrixFooter ${
                selectedClientId ? '' : 'disabled-overlay'
            }`}>
            {(checkSubModulesget)?.includes('Generate Attendance Register')&&(
              // setIsAttendanceExist
                <a className={`btn btn-primary AttendanceRegister`} href={isAttendance ? `/input-matrix/attendance-master/${dater}` : "#"} onClick={(e)=>{if(!isAttendance){
                  e.preventDefault();
                  showFormRelatedErrorIndepth();
                }}}>Attendance Register</a>
                )}
                {/* <a className="btn btn-outline-secondary GenerateForm" href={`/input-matrix/generate_form/${dater}`}>Generate Form</a> */}
                {(checkSubModulesget)?.includes('Generate Form')&&(
                <a className={`btn ${isAttendanceExist && dater === currentMonth ? "btn-outline-primary":"btn-outline-secondary"}`} onClick={dater === currentMonth ? handleToggleGenerateForm : handleToggleNonGenerateForm}
                >Generate Form</a>)}
            </div>
            {/* <React.Fragment>
                   <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Current Month ?"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            You are about to complete the current month and move to the next month.

                            Please verify all employee, attendance, leave, and salary information before proceeding, as any changes made later may affect future data.

                            Before continuing, ensure that all required  forms to be generated for the current month have been generated.

                            Do you want to continue?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={previousMonth}>Previous Month</Button>
                        <Button onClick={nextMonth}>Future Month</Button>
                        <Button onClick={handleClose}>Cancel</Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment> */}
            <Dialog
              open={open}
              onClose={handleClose}
              maxWidth="sm"
              fullWidth
              PaperProps={{
                sx: {
                  borderRadius: 3,
                  p: 1,
                },
              }}
            >
              <DialogTitle sx={{ pb: 1 }}>
                <Box display="flex" alignItems="center" gap={1}>
                  <WarningAmberRoundedIcon
                    sx={{ color: "#0D6EFD", fontSize: 34 }}
                  />
                  <Typography variant="h5" fontWeight="bold">
                    Select Current Month?
                  </Typography>
                </Box>
              </DialogTitle>

              <DialogContent>

                {step === 1 && (
                  <>
                    <Typography variant="body1" sx={{ mt: 2, fontWeight: 300 }}>
                      Would you like to move to the month?
                    </Typography>
                  </>
                )}

                {step === 2 && (
                  <>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      You are about to Move to the <b>Previous month.</b> 
                    </Typography>

                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 2 }}
                    >
                      Before proceeding, please ensure the following:
                    </Typography>

                    <Box
                      sx={{
                        background: "#fff",
                        borderLeft: "4px solid #0D6EFD",
                        borderRight: "4px solid #0D6EFD",
                        p: 2,
                        borderRadius: 2,
                      }}
                    >
                      {/* <Typography sx={{ mb: 1 }}>
                        ✔ Verify all employee, attendance, leave, and salary information.
                      </Typography>

                      <Typography sx={{ mb: 1 }}>
                        ✔ Generate all required forms.
                      </Typography> */}

                      <Typography color="error" fontWeight={600}>
                        ⚠ Any changes made in the previous month may affect to this current month.
                      </Typography>
                    </Box>

                    <Typography sx={{ mt: 2 }}>
                      Are you sure you want to continue?
                    </Typography>
                  </>
                )}

                {step === 3 && (
                  <>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      You are about to complete the <b>current month</b> and move to
                      <br />
                      <b>next month</b>.
                    </Typography>

                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 2 }}
                    >
                      Before proceeding, please ensure the following:
                    </Typography>

                    <Box
                      sx={{
                        background: "#fff",
                        borderLeft: "4px solid #0D6EFD",
                        borderRight: "4px solid #0D6EFD",
                        p: 2,
                        borderRadius: 2,
                      }}
                    >
                      <Typography sx={{ mb: 1 }}>
                        ✔ Verify all employee, attendance, leave, and salary information.
                      </Typography>

                      <Typography sx={{ mb: 1 }}>
                        ✔ Generate all required forms.
                      </Typography>

                      {/* <Typography color="error" fontWeight={600}>
                        ⚠ Any changes may affect future data.
                      </Typography> */}
                    </Box>

                    <Typography sx={{ mt: 2 }}>
                      Are you sure you want to continue?
                    </Typography>
                  </>
                )}

                

              </DialogContent>

              <DialogActions>

                {step === 1 && (
                  <>
                    {/* {isAttendanceExistPrevious && (
                      <Button onClick={handleCurrentMonthSelection}>
                        Edit
                      </Button>
                    )} */}

                    <Button onClick={handleClose}>
                      Cancel
                    </Button>

                    {isAttendanceExistPrevious && (
                      <Button onClick={() => setStep(2)}>
                      Previous Month
                    </Button>)}

                    <Button
                      variant="contained"
                      onClick={() => setStep(3)}
                      >
                      Next Month
                    </Button>
                  </>
                )}

                

                {step === 2 && (
                  <>
                    <Button onClick={() => setStep(1)}>
                      Back
                    </Button>

                    <Button
                      variant="contained"
                      onClick={previousMonth}
                      >
                      Confirm Previous
                    </Button>
                  </>
                )}

                {step === 3 && (
                  <>
                    <Button onClick={() => setStep(1)}>
                      Back
                    </Button>

                    <Button
                      variant="contained"
                      onClick={nextMonth}
                      >
                      Submit
                    </Button>
                  </>
                )}

              </DialogActions>
            </Dialog>




            {/* current month selection start from here */}

            <Dialog
              open={currentOpen}
              onClose={handleCurrentMonthClose}
              maxWidth="sm"
              fullWidth
              PaperProps={{
                sx: {
                  borderRadius: 3,
                  p: 1,
                },
              }}
            >
              <DialogTitle sx={{ pb: 1 }}>
                <Box display="flex" alignItems="center" gap={1}>
                  <CalendarMonthIcon
                    sx={{ color: "#0D6EFD", fontSize: 34 }}
                  />
                  <Typography variant="h5" fontWeight="bold">
                    Set Your Current Month?
                  </Typography>
                </Box>
              </DialogTitle>

              <DialogContent>

                {currentSetp === 1 && (
                  <>
                    <Typography variant="body1" sx={{ mt: 2, mb: 1, fontWeight: 300 }}>
                      Select your Current Month to set your Organization to be processed with that month.
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        mt: 1,
                      }}
                    >
                      <input
                        type="month"
                        value={selectedCurrentMonth}
                        onChange={(e) => {
                          setSelectedCurrentMonth(e.target.value);
                          setMonthError(false);
                        }}
                        style={{
                          width: "50%",
                          padding: "12px",
                          fontSize: "16px",
                          border: monthError ? "1px solid red" : "1px solid #0D6EFD",
                          borderRadius: "4px",
                        }}
                      />
                      {monthError && (
                          <Typography
                            color="error"
                            variant="caption"
                            sx={{
                              display: "block",
                              textAlign: "center",
                              mt: 2,
                            }}
                          >
                            &nbsp;Please select the current month.
                          </Typography>
                        )}
                    </Box>
                  </>
                )}

                {currentSetp === 2 && (
                  <>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      You are about to Move to the <b>Previous month.</b> 
                    </Typography>

                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 2 }}
                    >
                      Before proceeding, please ensure the following:
                    </Typography>

                    <Box
                      sx={{
                        background: "#fff",
                        borderLeft: "4px solid #0D6EFD",
                        borderRight: "4px solid #0D6EFD",
                        p: 2,
                        borderRadius: 2,
                      }}
                    >
                      {/* <Typography sx={{ mb: 1 }}>
                        ✔ Verify all employee, attendance, leave, and salary information.
                      </Typography>

                      <Typography sx={{ mb: 1 }}>
                        ✔ Generate all required forms.
                      </Typography> */}

                      <Typography color="error" fontWeight={600}>
                        ⚠ Any changes made in the previous month may affect to this current month.
                      </Typography>
                    </Box>

                    <Typography sx={{ mt: 2 }}>
                      Are you sure you want to continue?
                    </Typography>
                  </>
                )}

                {currentSetp === 3 && (
                  <>
                    <Typography variant="body1" sx={{ mb: 1, mt:1 }}>
                      You are about to set the <b>Current Month</b> for your organization.
                    </Typography>

                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 2 }}
                    >
                      Before proceeding, please ensure the following:
                    </Typography>

                    <Box
                      sx={{
                        background: "#fff",
                        borderLeft: "4px solid #0D6EFD",
                        borderRight: "4px solid #0D6EFD",
                        p: 1,
                        borderRadius: 2,
                      }}
                    >
                     <Typography sx={{ mb: 1 }} fontSize={15}>
                      ✔ The Current Month is a one-time setup that defines the starting month &nbsp;&nbsp;&nbsp;&nbsp;and cannot be changed later.
                    </Typography>

                    <Typography sx={{ mb: 1 }} fontSize={15}>
                      ✔ All future registers records will start from the selected Current Month.
                    </Typography>

                      {/* <Typography color="error" fontWeight={600}>
                        ⚠ Any changes may affect future data.
                      </Typography> */}
                    </Box>

                    <Typography sx={{ mt: 2 }}>
                      Are you sure you want to continue?
                    </Typography>
                  </>
                )}

                

              </DialogContent>

              <DialogActions sx = {{justifyContent:'center'}}>

                {currentSetp === 1 && (
                  <>
                    {/* <Button variant="contained" onClick={() => setCurrentStep(3)}>
                      Confirm
                    </Button> */}

                    <Button
                      variant="contained"
                      onClick={() => {
                        if (!selectedCurrentMonth) {
                          setMonthError(true);
                          return;
                        }

                        setMonthError(false);
                        setCurrentStep(3);
                      }}
                    >
                      Confirm
                    </Button>


                    <Button
                      variant="contained"onClick={handleCurrentMonthClose}
                      >
                      Cancel
                    </Button>
                  </>
                )}

                {currentSetp === 2 && (
                  <>
                    <Button onClick={() => setCurrentStep(1)}>
                      Back
                    </Button>

                    <Button
                      variant="contained"
                      onClick={previousMonth}
                      >
                      Confirm Previous
                    </Button>
                  </>
                )}

                {currentSetp === 3 && (
                  <>
                    <Button onClick={() => setCurrentStep(1)}>
                      Back
                    </Button>

                    <Button
                      variant="contained"
                      onClick={CreateMonth}
                      >
                      Submit
                    </Button>
                  </>
                )}

              </DialogActions>
            </Dialog>
            {isVisible && (
              <>
                    <div className="overlaydataaa"></div>
                    <div className="generate-form-module shadow ">
                        <div className="generate-forms-header d-flex justify-content-between">
                            <div className="div">
                                <h5><b>Generate Form</b></h5>
                                <p>Branch-wise forms generated instantly with accurate compliance mapping Automatically generate forms based on the selected Branches</p>
                            </div>
                            <div>
                            <button
                                className="into-btn-icon"
                                onClick={() => setIsVisible(false)}
                            >
                                <img src={intomarkIcon} alt="" />
                            </button>
                            </div>
                        </div>
                        <div className="div">
                            <div className="container mt-2">
                                <div className="mb-3 radio-container d-flex">
                                    <label className="d-flex align-items-center  me-5" style={{ cursor: 'pointer' }}>
                                        <input
                                            type="radio"
                                            name="formSelector"
                                            value="Generate Form"
                                            checked={selectedFormtable === 'Generate Form'}
                                            onChange={handleChangeforms}
                                            className="me-3"
                                        />Generate Form
                                    </label>
                                    <label className="d-flex align-items-center" style={{ cursor: 'pointer' }}>
                                        <input
                                            type="radio"
                                            name="formSelector"
                                            value="Update Generated Form"
                                            checked={selectedFormtable === 'Update Generated Form'}
                                            onChange={handleChangeforms}
                                            className="me-3"
                                        />
                                        Update Generated Form
                                        </label>
                                </div>

                                <div className="form-container">
                                    {/* {selectedFormtable === 'Generate Form' && (
                                        <>
                                            <form onSubmit={handleFormSubmit}>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                        <div className="col-md-6">
                                                            <label className="form-label">Org. ID</label>
                                                            <input className="form-control" type="text" value={clientID } disabled/>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label className="form-label">Date</label>
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                value={formattedDate}
                                                                disabled
                                                            />
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mb-1">
                                                    <label className="form-label">Branch <span className='text-danger'>*</span></label>
                                                    <select className="form-select " value={selectedUnit} onChange={handleUnitChange}>
                                                        <option value="">Select Unit</option>
                                                        {unitOptions.map((unit) => (
                                                        <option key={unit.unit_id} value={unit.unit_id}>
                                                            {unit.unit_id}
                                                        </option>
                                                        ))}
                                                    </select>
                                    
                                                </div>
                                                <div className="mb-1">
                                                    <label className="form-label">Form <span className='text-danger'>*</span></label>
                                                    <Select
                                                        options={formOptions}
                                                        value={formOptions.find(option => option.value === selectedForm)}
                                                        onChange={(selectedOption) => handleFormTypeChange({ target: { value: selectedOption?.value } })}
                                                        placeholder="Select Form Type"
                                                        isSearchable
                                                        styles={customStyles}
                                                    />
                                                </div>
                                                <button type="submit" className="btn  w-100 submit">Submit</button>
                                            </form>
                                            {successMessage && (
                                                <div className="alert alert-success mt-3">{successMessage}</div>
                                            )}
                                            {failMessage && <div className="alert alert-danger mt-3">{failMessage}</div>}
                                        </>
                                    )} */}

{selectedFormtable === 'Generate Form' && (
  <>
    <form onSubmit={handleFormSubmit}>
      <div className="row">
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-6">
              <label className="form-label">Org. ID</label>
              <input className="form-control" type="text" value={clientID} disabled />
            </div>
            <div className="col-md-6">
              <label className="form-label">Date</label>
              <input
                className="form-control"
                type="text"
                value={formattedDate}
                disabled
              />
            </div>
          </div>
        </div>
      </div>

      <div className="mb-1 branch-select-field">
        <label className="form-label">Branch <span className='text-danger'>*</span></label>
        <select className="form-select" value={selectedUnit} onChange={handleUnitChange}>
          <option value="">Select Unit</option>
          {unitOptions.map((unit) => (
            <option key={unit.unit_id} value={unit.unit_id}>
              {unit.unit_id}
            </option>
          ))}
        </select>
      </div>

      <div className="mb-6radio-container d-flex">
        <label
          className="d-flex align-items-center me-3"
          style={{ cursor: isOnRoll ? 'pointer' : 'not-allowed', opacity: isOnRoll ? 1 : 0.5 }}
        >
          <input
            type="radio"
            name="formCategory"
            value="1"
            checked={selectedFormCategory === '1'}
            onChange={() => handleFormCategoryChange('1')}
            disabled={!isOnRoll}
            className="me-3"
          />
          S&E Forms
        </label>
        <label
          className="d-flex align-items-center"
          style={{ cursor: isContractor ? 'pointer' : 'not-allowed', opacity: isContractor ? 1 : 0.5 }}
        >
          <input
            type="radio"
            name="formCategory"
            value="2"
            checked={selectedFormCategory === '2'}
            onChange={() => handleFormCategoryChange('2')}
            disabled={!isContractor}
            className="me-3"
          />
          CLRA Forms
        </label>
        <label
          className="d-flex align-items-center"
          style={{ cursor: isBoth ? 'pointer' : 'not-allowed', opacity: isBoth ? 1 : 0.5 }}
        >
          <input
            type="radio"
            name="formCategory"
            value="3"
            checked={selectedFormCategory === '3'}
            onChange={() => handleFormCategoryChange('3')}
            disabled={!isBoth}
            className="me-2 ms-2"
          />
          Both S&E and CLRA Forms
        </label>
      </div>

      <div className="mb-1">
        <label className="form-label">Form <span className='text-danger'>*</span></label>
        <div className="border rounded p-2 bg-light">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <label className="m-0 d-flex align-items-center" style={{ cursor: "pointer" }}>
              <input
                type="checkbox"
                className="me-2"
                checked={formOptions.length > 0 && selectedForms.length === formOptions.length}
                onChange={toggleSelectAllForms}
              />
              Select All
            </label>
            <small className="text-muted">{selectedForms.length} selected</small>
          </div>
          <div style={{ maxHeight: "150px", overflowY: "auto" }}>
            {formOptions.length === 0 ? (
              <small className="text-muted">No forms available for selected branch</small>
            ) : (
              formOptions.map((option) => (
                <label
                  key={option.value}
                  className="d-flex align-items-center mb-1"
                  style={{ cursor: "pointer" }}
                >
                  <input
                    type="checkbox"
                    className="me-2"
                    checked={selectedForms.includes(option.value)}
                    onChange={() => toggleFormSelection(option.value)}
                  />
                  <span>{option.label}</span>
                </label>
              ))
            )}
          </div>
        </div>
      </div>

      {/* ✅ NEW — Download Format Selector */}
      <div className="mb-2 mt-2">
        <label className="form-label fw-semibold">
          Download Format <span className="text-danger">*</span>
        </label>
        <div className="d-flex gap-3 format-selector">

          {/* Excel */}
          <label
            className={`format-option d-flex align-items-center gap-2 px-3 py-2 rounded border ${
              selectedFormat === 'excel'
                ? 'border-success bg-success-subtle text-success fw-semibold'
                : 'border-secondary text-muted'
            }`}
            style={{ cursor: 'pointer', transition: 'all 0.2s' }}
          >
            <input
              type="radio"
              name="downloadFormat"
              value="excel"
              checked={selectedFormat === 'excel'}
              onChange={() => setSelectedFormat('excel')}
              className="d-none"
            />
            {/* Excel icon */}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <rect width="24" height="24" rx="4" fill={selectedFormat === 'excel' ? '#1D6F42' : '#ccc'} />
              <text x="4" y="17" fontSize="11" fill="white" fontWeight="bold">XLS</text>
            </svg>
            Excel (.xlsx)
          </label>

          {/* PDF */}
          <label
            className={`format-option d-flex align-items-center gap-2 px-3 py-2 rounded border ${
              selectedFormat === 'pdf'
                ? 'border-danger bg-danger-subtle text-danger fw-semibold'
                : 'border-secondary text-muted'
            }`}
            style={{ cursor: 'pointer', transition: 'all 0.2s' }}
          >
            <input
              type="radio"
              name="downloadFormat"
              value="pdf"
              checked={selectedFormat === 'pdf'}
              onChange={() => setSelectedFormat('pdf')}
              className="d-none"
            />
            {/* PDF icon */}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <rect width="24" height="24" rx="4" fill={selectedFormat === 'pdf' ? '#E53935' : '#ccc'} />
              <text x="4" y="17" fontSize="11" fill="white" fontWeight="bold">PDF</text>
            </svg>
            PDF (.pdf)
          </label>

          {/* Both */}
          <label
            className={`format-option d-flex align-items-center gap-2 px-3 py-2 rounded border ${
              selectedFormat === 'both'
                ? 'border-primary bg-primary-subtle text-primary fw-semibold'
                : 'border-secondary text-muted'
            }`}
            style={{ cursor: 'pointer', transition: 'all 0.2s' }}
          >
            <input
              type="radio"
              name="downloadFormat"
              value="both"
              checked={selectedFormat === 'both'}
              onChange={() => setSelectedFormat('both')}
              className="d-none"
            />
            {/* Both icon */}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <rect width="24" height="24" rx="4" fill={selectedFormat === 'both' ? '#1565C0' : '#ccc'} />
              <text x="2" y="17" fontSize="9" fill="white" fontWeight="bold">BOTH</text>
            </svg>
            Both (.zip)
          </label>

        </div>
        <small className="text-muted">
          {selectedFormat === 'both'
            ? 'Downloads a .zip file containing both Excel and PDF versions.'
            : `Downloads the form as a ${selectedFormat === 'excel' ? '.xlsx (Excel)' : '.pdf'} file.`}
        </small>
      </div>
      {/* ── end format selector ── */}

      <button type="submit" className="btn w-100 submit mt-2">Submit</button>
    </form>

    {successMessage && (
      <div className="alert alert-success mt-3">{successMessage}</div>
    )}
    {failMessage && (
      <div className="alert alert-danger mt-3">{failMessage}</div>
    )}
  </>
)}
                                    {selectedFormtable === 'Update Generated Form' && (
                                        <>
                                        <form onSubmit={handleFormSubmit}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="row">
                                                    <div className="col-md-6">
                                                        <label className="form-label">Org. ID</label>
                                                        <input className="form-control" type="text" value={clientID } disabled/>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="form-label">Date</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={formattedDate}
                                                            disabled
                                                        />
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mb-1">
                                                <label className="form-label">Branch <span className='text-danger'>*</span></label>
                                                <select className="form-select " value={selectedUnit} onChange={handleUnitChange}>
                                                    <option value="">Select Unit</option>
                                                    {unitOptions.map((unit) => (
                                                    <option key={unit.unit_id} value={unit.unit_id}>
                                                        {unit.unit_id}
                                                    </option>
                                                    ))}
                                                </select>
                                
                                            </div>
                                            <div className="mb-1">
                                                <label className="form-label">Form <span className='text-danger'>*</span></label>
                                                <Select
                                                    options={formOptions}
                                                    value={formOptions.find(option => option.value === selectedForm)}
                                                    onChange={(selectedOption) => handleFormTypeChange({ target: { value: selectedOption?.value } })}
                                                    placeholder="Select Form Type"
                                                    isSearchable
                                                    styles={customStyles}
                                                />
                                            </div>
                                            <div className="mb-1">
                                                <label htmlFor="">Upload Your Excel</label>
                                                <div className="row">
                                                    <div className="col-md-12 upload-box-main1 ">
                                                        <div
                                                            className={`upload-box d-flex align-items-center justify-content-between ${
                                                            dragActive ? "drag-active" : ""
                                                            }`}
                                                            onDragOver={(e) => {
                                                            e.preventDefault();
                                                            setDragActive(true);
                                                            }}
                                                            onDragLeave={() => setDragActive(false)}
                                                            onDrop={handleDrop}
                                                        >
                                                            <div className="d-flex align-items-center">
                                                            <div className="upload-icon me-2">
                                                                <img src={file_upload_icon} alt="no img" />
                                                            </div>
                                                            <div>
                                                                <p className="p-0 m-0">
                                                                {dragActive ? "Drop file here" : "Select a file or drag and drop here"}
                                                                </p>
                                                                <small className="text-muted">
                                                                Only supports .xlsx
                                                                </small>
                                                            </div>
                                                            </div>
                                                            <a
                                                            onClick={() => document.getElementById("fileInput").click()}
                                                            >
                                                            SELECT FILE
                                                            </a>
                                                            <input
                                                            type="file"
                                                            id="fileInput"
                                                            className="d-none"
                                                            onChange={handleFileChange}
                                                            accept=".xls,.xlsx"
                                                            />
                                                        </div>
                                                    </div>

                                                    {file && (
                                                    <div className="col-md-12 uploaded-box-main1 p-0 m-0">
                                                        <div className="uploaded-file d-flex align-items-center justify-content-between">
                                                        <div className="d-flex align-items-center">
                                                            <img src={file_uploaded_icon} alt="no img" />
                                                            <div>
                                                            <p className="mb-0 uploaded-file-name">{file.name}</p>
                                                            <small className="text-muted uploaded-file-size">{file.size}</small>
                                                            </div>
                                                        </div>
                                                        <a
                                                            className="close-btn p-0"
                                                            onClick={removeFile}
                                                        >
                                                            <img src={into} alt="noImg" />
                                                        </a>
                                                        </div>
                                                    </div>
                                                    )}
                                                </div>
                                            </div>
                                            <button type="submit" className="btn  w-100 submit">Submit</button>
                                        </form>
                                        {successMessage && (
                                            <div className="alert alert-success mt-3">{successMessage}</div>
                                        )}
                                        {failMessage && <div className="alert alert-danger mt-3">{failMessage}</div>}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
            {isVisibleCompleteError && (
              <>
                <div className="overlaydataaa"></div>

                <div className="error-display-module shadow">
                  <div className="d-flex justify-content-between">
                    <div>
                      {/* <h5 className='text-danger'><b>Error</b></h5> */}
                    </div>
                  </div>
                  <div className="container mt-3">
                    <div className="alert alert-danger">
                      <b>Before generating Attendance, please upload salary register for the following employees.</b>
                    </div>
                    <div className="alert alert-danger">
                    <div className="table-responsive" style={{ maxHeight:"300px", overflow:"auto" }}>
                      <table className="table table-bordered table-transparent">
                        <thead className="table-transparent sticky-top">
                          <tr>
                            <th>Employee Code</th>
                            <th>Employee Name</th>
                            <th>Branch ID</th>
                          </tr>
                        </thead>
                        <tbody>
                          {totalBranchAccessCount?.length > 0 ? (
                            totalBranchAccessCount.map((emp, index) => (
                              <tr key={index}>
                                <td>{emp.emp_code}</td>
                                <td>{emp.emp_name}</td>
                                <td>{emp.unit_id}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" className="text-center">
                                No records found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    </div>
                    <p className='notedata text-danger'><b>Note:</b>Total {totalBranchAccessCount?.length} employee's salary register should be uploaded </p>
                    <div className='float-end'>
                      <button
                        type="button"
                        className='btn btn-sm btn-primary me-3'
                        onClick={() => {
                          const rows = Array.isArray(totalBranchAccessCount) ? totalBranchAccessCount : [];
                          const sheetRows = rows.map((emp) => ({
                            "Employee Code": emp.emp_code || "",
                            "Employee Name": emp.emp_name || "",
                            "Branch ID": emp.unit_id || "",
                          }));
                          const ws = XLSX.utils.json_to_sheet(
                            sheetRows.length
                              ? sheetRows
                              : [{ "Employee Code": "", "Employee Name": "", "Branch ID": "" }]
                          );
                          const wb = XLSX.utils.book_new();
                          XLSX.utils.book_append_sheet(wb, ws, "Missing Employees");
                          XLSX.writeFile(wb, "missing_employees_salary_register.xlsx");
                        }}
                      >
                        Download Excel
                      </button>
                      <a className='btn btn-sm btn-success me-3' href={`/input-matrix/salary-register/${dater}`}>Upload Salary register</a>
                      <a className='btn btn-sm btn-danger' onClick={() => setIsVisibleCompleteError(false)}>close</a>
                    </div>
                    
                  </div>
                </div>
              </>
            )}

        </div>
    );
}

const CardItem = ({ link, label, image, iconBackground, hoverBackground ,dataContent}) => {
  const [isHovered, setIsHovered] = useState(false);

  const cardStyle = {
    backgroundColor: isHovered ? hoverBackground : "white",
    transition: "background-color 0.3s ease",
    textDecoration: "none",
    color: "inherit",
  };

  return (
    <div className="col card-mainheader">
      <a
        href={link}
        className="card formCard text-decoration-none text-dark"
        style={cardStyle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="card-body">
          <div
            className="cardicon"
            style={{ background: iconBackground }}
          >
            <img src={image} alt="icon" className="formicons" />
          </div>
          <h6>{label}</h6>
          <p className="small text-muted">
            {dataContent}
          </p>
          <button className="btn  bg-white">Click here <IoIosArrowForward /></button>
        </div>
      </a>
    </div>
  );
};


export default UploadForm;










